"use client";
import type { ReactElement } from "react";
import { getFontFamily } from "@/theme/typography";
export interface GanttTooltipDateRangeProps {
    startLabel: string;
    endLabel: string;
}
export function GanttTooltipDateRange({ startLabel, endLabel, }: GanttTooltipDateRangeProps): ReactElement {
    return (
      <div style={{
            fontFamily: getFontFamily(),
            fontSize: 11,
            color: "rgba(255,255,255,0.72)",
            lineHeight: "15px",
        }}>
        {startLabel} - {endLabel}
      </div>
    );
}
